<template>
    <a v-if="shouldShow()" :href="href()"><slot></slot></a>
</template>

<script setup lang="ts">
    import {usePrismicFieldHelpers, useTypeGuards} from '@navbar-unlogged/composables';
    import {linkResolver} from '@navbar-unlogged/helpers';
    import type {KeyTextField, LinkField} from '@prismicio/types';
    import {useLocalePrefix} from '#imports';

    const {withLocalePrefix} = useLocalePrefix();

    const {isLink} = usePrismicFieldHelpers();

    const {isFilledWebLink, isFilledKeyText, isFilledContentRelationshipField} = useTypeGuards();

    const props = defineProps<{
        field: LinkField | KeyTextField;
    }>();

    function shouldShow(): boolean {
        return isFilledKeyText(props.field) || isLink('_', props.field);
    }

    function prefixIfInternal(path: string): string {
        if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('//')) {
            return path;
        }
        return withLocalePrefix(path);
    }

    function href(): string {
        const field = props.field;
        if (isFilledKeyText(field)) {
            return prefixIfInternal(field);
        }
        if (field && isFilledWebLink(field)) {
            return field.url;
        }
        if (field && isFilledContentRelationshipField(field)) {
            return linkResolver(field);
        }
        return '';
    }
</script>
